export default __webpack_public_path__ + "static/media/blue-vs-orange-circuits.9a91dc0e.png";